/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Grant_GrantBulkExportDto } from '../models/Wealthlane_AwardService_Dtos_Grant_GrantBulkExportDto';
import type { Wealthlane_AwardService_Dtos_Plan_GrantBulkSelectDeselectDto } from '../models/Wealthlane_AwardService_Dtos_Plan_GrantBulkSelectDeselectDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GrantFilterService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Grant_GrantBulkExportDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppGrantFilterBulkExportGrantByFilter(
requestBody?: Wealthlane_AwardService_Dtos_Plan_GrantBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Grant_GrantBulkExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/grant-filter/bulk-export-grant-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
